import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, useParams } from "react-router";
import { Loading } from "@/layouts/components";
import { RoutesListGame } from "@/router/routesPath/routesListGame";
import { useAcceptInviteMutation } from "@/store/api";
/** Используется только для прямых ссылок снаружи */
export var GameAction = function (props) {
    var gameId = useParams().gameId;
    var _a = useAcceptInviteMutation(), acceptInviteAction = _a[0], acceptInviteState = _a[1];
    if (props.action === "accept") {
        acceptInviteAction({ id: gameId });
    }
    var isLoading = acceptInviteState.isLoading;
    return isLoading ? (_jsx(Loading, {})) : (_jsx(Navigate, { to: RoutesListGame.getGameDetails(gameId) }));
};
